import { ExternalComponentSiteConfig } from '../types'

const getClientConfig = ({ forceBundlerDevMode }: { forceBundlerDevMode: boolean }) =>
	forceBundlerDevMode || process.env.NODE_ENV === 'development' ? 'REMOTE_UI_DEV' : 'REMOTE_UI'
const getSsrConfig = ({ forceBundlerDevMode }: { forceBundlerDevMode: boolean }) =>
	forceBundlerDevMode || process.env.NODE_ENV === 'development' ? 'REMOTE_UI_SSR_DEV' : 'REMOTE_UI_SSR'

const generateWixCodeUrl = ({
	wixCodeBundlersUrlData,
	url: fileUrl,
	forceBundlerDevMode,
	cacheKillerCounter,
	appDefId = '',
}: {
	wixCodeBundlersUrlData: ExternalComponentSiteConfig['wixCodeBundlersUrlData']
	url: string
	forceBundlerDevMode: boolean
	cacheKillerCounter?: number
	appDefId?: string
}) => {
	const { url, queryParams } =
		wixCodeBundlersUrlData.appDefIdToWixCodeBundlerUrlData[appDefId] ?? wixCodeBundlersUrlData

	const head = url + fileUrl.replace('public/', '')
	const configType = process.env.browser
		? getClientConfig({ forceBundlerDevMode })
		: getSsrConfig({ forceBundlerDevMode })
	const tail = [
		'no-umd=false',
		queryParams,
		typeof cacheKillerCounter === 'undefined' ? '' : `cacheKiller=${cacheKillerCounter}`,
		`byoc-config=${configType}`,
	]
		.filter((v) => v !== '')
		.join('&')
	return `${head}?${tail}`
}

export default generateWixCodeUrl
